// Shared helpers for the /ffv/:ticker landing flow: ticker validation, UTM
// extraction, and carrying the destination through the Cognito hosted-UI
// redirect via sessionStorage (the redirect_uri is a fixed URL, so query
// params cannot survive the round-trip on their own).

const STORAGE_KEY = "tickrtrends_pending_ffv";
const MAX_AGE_MS = 24 * 60 * 60 * 1000; // signup + email confirm can take a while

export const TICKER_PATTERN = /^[A-Za-z0-9.-]{1,6}$/;

export const isValidTicker = (value) =>
  typeof value === "string" && TICKER_PATTERN.test(value.trim());

export const normalizeTicker = (value) => String(value).trim().toUpperCase();

// Returns a query fragment like "utm_source=x&utm_medium=y" (no leading "?"),
// or "" when the search string carries no UTM params.
export const extractUtmString = (search) => {
  const params = new URLSearchParams(search);
  const utm = new URLSearchParams();
  params.forEach((value, key) => {
    if (key.toLowerCase().startsWith("utm_")) {
      utm.append(key, value);
    }
  });
  return utm.toString();
};

export const savePendingDestination = ({ ticker, utm }) => {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ticker: normalizeTicker(ticker), utm: utm || "", savedAt: Date.now() })
    );
  } catch (storageError) {
    // Storage unavailable (private mode) — the direct-URL path still works.
  }
};

export const consumePendingDestination = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(STORAGE_KEY);

    const parsed = JSON.parse(raw);
    if (!parsed || !isValidTicker(parsed.ticker)) return null;
    if (Date.now() - (parsed.savedAt || 0) > MAX_AGE_MS) return null;

    return { ticker: normalizeTicker(parsed.ticker), utm: parsed.utm || "" };
  } catch (storageError) {
    return null;
  }
};
